/*
 * file: function.js
 * 상세: 함수 모음
 */

/**
 * 빈 값 체크 (빈값: true, 값 존재: false)
 * @param {String} value 비교 값
 */
function Empty(value) {
  if (typeof value === 'number') {
    return (value === 0)
  }
  if (typeof value === 'function') {
    return false
  }
  return (
    value === null ||
    value === undefined ||
    value === '' ||
    value === false ||
    value.length === 0 ||
    Object.keys(value).length === 0
  );
}

/**
 * 검색필드에서 엔터 키 눌렀을 때 핸들러
 * @param {String} val 키 누른 값
 * @param {String} value 발생 시킬 이벤트
 */
function enterEvent(val, func) {
  if (val.key === 'Enter') {
    func()
  }
}

/**
 * 파일 정보 추출
 * @param {Int} bytes 파일 크기
 * @param {Int} decimals 파일 크기 연산
 */
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

/**
 * YYY-MM-DD HH:II:SS 날짜 포맷팅
 * @param {Date} inputDate 날짜
 * @param {boolean} time 시간까지 나오게 하는지(기본값: false)
 */
function FormatDate(inputDate, time = false) {
  if (Empty(inputDate)) return '-';
  
  var date = new Date(inputDate);
  const yyyy = date.getFullYear();
  const mm = ('0' + (date.getMonth() + 1)).slice(-2);
  const dd = ('0' + date.getDate()).slice(-2);
  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);
  const seconds = ("0" + date.getSeconds()).slice(-2);
  return time ? `${yyyy}-${mm}-${dd} ${hours}:${minutes}:${seconds}` : `${yyyy}-${mm}-${dd}`;
}
/**
 * 일자를 시간으로 치완
 * @param {String} value 일 HH:II:SS
 */
function DayToHours(value) {

  const parts = value.match(/(\d+)일 (\d+):(\d+):(\d+)/);

  let days = parseInt(parts[1], 10);
  let hours = parseInt(parts[2], 10);
  let minutes = parseInt(parts[3], 10);
  let seconds = parseInt(parts[4], 10);

  hours += days * 24;

  let hoursStr = String(hours).padStart(2, '0');
  let minutesStr = String(minutes).padStart(2, '0');
  let secondsStr = String(seconds).padStart(2, '0');

  return `${hoursStr}:${minutesStr}:${secondsStr}`;
}
/**
 * 날짜 남은 일수 계산
 * @param {int} start 시작 일자
 * @param {int} end 종료 일자
 */
function D_day(start, end){
  let startDate = new Date(start);
  let endDate = new Date(end);
  let diffTime  = endDate - startDate;
  const diffHours = diffTime / (1000 * 60 * 60);

  if (diffHours >= 24) {
    const days = Math.floor(diffHours / 24);
    return `${days} 일간`;
  } else {
    return `${Math.floor(diffHours)} 시간`;
  }
}
/**
 * 타이머
 * @param {Object} datas 데이터
 * @param {Function} updateTimer 업데이트 함수
 * @param {Function} callBack 콜백 함수 (기본 값 null)
 */
const Timer = (datas, updateTimer, callBack = null) => {

  const data = datas.filter((item) => item.tournament_deadline_time.includes('-'));
  let total_seconds = {};
  let time = {};
  let timers = {}

  data.forEach((item, index) => {
    const value = item.tournament_deadline_time.replace('-', '')
    time = value.includes('일') ? DayToHours(value) : value;
    time = time.split(':').map(Number); 
    total_seconds[index] = time[0] * 60 * 60 + time[1] * 60 + time[2];

    timers[index] = setInterval(() => {
      total_seconds[index]--;
      if (total_seconds[index] === 0) {
        clearInterval(timers[index]);
        !Empty(callBack) && callBack()
      }

      let days = Math.floor(total_seconds[index] / (3600 * 24));
      let hours = Math.floor((total_seconds[index] - (days * 3600 * 24)) / 3600);
      let minutes = Math.floor((total_seconds[index] - (days * 3600 * 24) - (hours * 3600)) / 60);
      let seconds = total_seconds[index] - (days * 3600 * 24) - (hours * 3600) - (minutes * 60);

      hours = String(hours).padStart(2, '0');
      minutes = String(minutes).padStart(2, '0');
      seconds = String(seconds).padStart(2, '0');

      const timeString = days > 0 ? `${days}일 ${hours}:${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`
      updateTimer((currentData) => ({ ...currentData, [item.tournament_idx]: timeString }))

    }, 1000)
  })
}
/**
 * 문자열 특정 길이 초과 시 ... 표기
 * @param {String} text 문자열
 * @param {String} maxLength 길이 값
 */
function stringCrop(text, maxLength) {
  const truncatedString = text.length > maxLength
    ? text.substring(0, maxLength) + "..."
    : text
  
  return truncatedString
}

/**
 * 패스워드 조건
 * @param {String} text 비밀번호
 */
function CheckPassword(text) {
  const condition = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return condition.test(text)
}

/**
 * JWT 치환
 * @param {String} token 토큰 값
 */
function TokenSubstitution(token) {
  if (Empty(token)) return;
  const base64Payload = token.split('.')[1];
  const payload = JSON.parse(atob(base64Payload));
  return payload
}

/**
 * 유저 로그인 체크
 */
function CheckUser() {

  const queryParams = new URLSearchParams(window.location.search);
  if (!Empty(queryParams.get('userid')) && !Empty(queryParams.get('key'))) return false

  const user = localStorage.getItem('info');

  if (Empty(user)) {
    return false;
  } else {
    return true;
  }
}

/**
 * 랜덤 Key 생성
 */
function RandomKey() {
  const randomPart = Math.random().toString(36).substring(2, 15);
  const timestampPart = Date.now().toString(36);
  return `${randomPart}-${timestampPart}`;
}

export { D_day, DayToHours, Empty, CheckUser, enterEvent, formatBytes, FormatDate, stringCrop, CheckPassword, TokenSubstitution, Timer, RandomKey }